import React from 'react';

const ConfirmationDialogContent = () =>
  (
    <div>
      By clicking save you are confirming the user exists in Microsoft Entra.
    </div>
  );


export default ConfirmationDialogContent;
